import { TbHome } from "react-icons/tb";

import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const homeRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.ROOT,
        meta: {
            label: "home",
            order: 1,
            icon: TbHome,
            visibleInSidebar: true,
        },
    },
];
